import { render, staticRenderFns } from "./transportFullInfo.vue?vue&type=template&id=2d295d3d&scoped=true&"
import script from "./transportFullInfo.vue?vue&type=script&lang=js&"
export * from "./transportFullInfo.vue?vue&type=script&lang=js&"
import style0 from "./transportFullInfo.vue?vue&type=style&index=0&id=2d295d3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d295d3d",
  null
  
)

export default component.exports